export default "__VITE_ASSET__f120ec27__"